import Index from './Index';
import SettingsContent from '../Wrapper';
import Webhook from './Webhooks/Index';
import DashboardApps from './DashboardApps/Index';
import WebhooksSendMessage from './WebhooksSendMessage/Index';
import webhooksSendMessageLogs from './webhooksSendMessageLogs/Index';
import Assistent from './Assistents/Index';
import Syonet from './syonet/Index';
import ShowIntegration from './ShowIntegration';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/applications'),
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name !== 'settings_integrations';
        const backUrl =
          params.name === 'settings_integrations_integration'
            ? { name: 'settings_integrations' }
            : '';
        return {
          headerTitle: 'INTEGRATION_SETTINGS.HEADER',
          icon: 'flash-on',
          showBackButton,
          backUrl,
        };
      },
      children: [
        {
          path: '',
          name: 'settings_integrations',
          component: Index,
          roles: ['administrator', 'supervisor'],
          accountTypes: ['account', 'subaccount', 'parent_account']
        },
        {
          path: 'webhook',
          component: Webhook,
          name: 'settings_integrations_webhook',
          roles: ['administrator', 'supervisor'],
        },
        {
          path: 'dashboard-apps',
          component: DashboardApps,
          name: 'settings_integrations_dashboard_apps',
          roles: ['administrator', 'supervisor'],
          accountTypes: ['account', 'subaccount', 'parent_account']
        },
        {
          path: 'webhooks-send-messages/logs',
          component: webhooksSendMessageLogs,
          name: 'settings_integrations_webhooks_send_message_logs',
          roles: ['administrator', 'supervisor'],
        },
        {
          path: 'webhooks-send-messages/:partner',
          component: WebhooksSendMessage,
          name: 'settings_integrations_webhooks_send_message',
          roles: ['administrator', 'supervisor'],
        },
        {
          path: 'syonet',
          component: Syonet,
          name: 'settings_integrations_syonet',
          roles: ['administrator', 'supervisor'],
        },
        {
          path: 'assistent',
          component: Assistent,
          name: 'settings_integrations_assistent',
          roles: ['administrator', 'supervisor'],
        },
        
        {
          path: ':integration_id',
          name: 'settings_integrations_integration',
          component: ShowIntegration,
          roles: ['administrator', 'supervisor'],
          props: route => {
            return {
              integrationId: route.params.integration_id,
              code: route.query.code,
            };
          },
        },        
      ],
    },
  ],
};
